export default {
  payment_methods: {
    sofort: 'Sofort',
    giropay: 'Giropay',
    iban: 'EC-Karte /IBAN',
    cash: 'Barzahlung',
  },
};
